import API from './api/index'

async function validateSession () {
  const token = await API.auth.verify(window.localStorage.getItem('token'))
  if (!token._id) {
    window.localStorage.clear()
    window.location = '/'
  }
}

export default {
  validateSession
}
